export const getVideoMediafileUploadTag = (companyId: string) => `video-mediafiles:${companyId}`;
